<div [formGroup]="form"
     class="container">

    <div class="gup-C-flexGroup -row -justifyBetween -alignCenter" [kalLoading]="loading">

        <ng-container *ngIf="!loading">
            <!-- Moyen de paiement -->
            <p *ngIf="!hasPaymentMethods; else paymentMethod"
               class="gup-O-msg -error">
                Le paramétrage actuel ne vous permet pas de régler ces factures
            </p>

            <ng-template #paymentMethod>

                <div class="gup-C-flexGroup__item -demi">

                    <kal-form-field>

                        <kal-select formControlName="paymentMethodCode"
                                    id="activity_payment_methods_payment_method"
                                    label="Moyen de paiement"
                                    placeholder="Sélectionner"
                                    required>

                            <kal-option *ngFor="let paymentMethod of (paymentMethodsList)"
                                        [value]="paymentMethod.Code">
                                {{ paymentMethod.Libelle }}
                            </kal-option>

                        </kal-select>

                    </kal-form-field>

                </div>

                <!-- Date -->
                <div *ngIf="selectedPaymentMethod"
                     class="gup-C-flexGroup__item -demi">

                    <kal-form-field>

                        <kal-datepicker formControlName="date"
                                        id="activity_payment_methods_date"
                                        label="Date"
                                        required>
                        </kal-datepicker>

                    </kal-form-field>

                </div>

            </ng-template>

        </ng-container>
    </div>

    <ng-container *ngIf="selectedPaymentMethod">

        <!-- Montant -->
        <div class="gup-C-flexGroup -row -justifyStart -alignCenter">

            <div class="gup-C-flexGroup__item -demi">

                <kal-form-field>

                    <kal-input formControlName="amount"
                               id="activity_payment_methods_amount"
                               label="Montant"
                               type="currency"
                               [errorsMessage]="{max: 'Le montant ne peut pas dépasser {max}€'}"
                               icon="euro"
                               required>
                    </kal-input>

                    <a id="activity_payment_methods_reset_amount"
                       (click)="resetAmount()"
                       class="gup-O-link -secondary">
                        Réinitialiser
                    </a>

                </kal-form-field>

            </div>

            <div class="gup-C-flexGroup__item">

                <kal-form-field class="without-label" *ngIf="overPayment > 0">

                    <span class="gup-U-color--red">
                            Trop perçu de {{ overPayment | currency:'EUR' }}
                    </span>

                </kal-form-field>

            </div>

        </div>

        <!-- Echéancier -->
        <div *ngIf="canUseRepaymentSchedule"
             class="repayment gup-C-flexGroup -row -justifyStart -alignCenter">
            <div class="gup-C-flexGroup__item -demi">

                <a class="gup-C-moreInfos gup-O-link"
                   [ngClass]="{'-underline': !!repaymentSchedule}"
                   (click)="openRepaymentScheduleDialog()">
                    <ng-container *ngIf="!repaymentSchedule; else repaymentScheduleSpan">
                        <kal-icon>
                            <i class="material-icons">add</i>
                        </kal-icon>

                        <span>Créer un échéancier</span>
                    </ng-container>

                    <ng-template #repaymentScheduleSpan>
                        <span>
                            Echéancier X {{repaymentSchedule.numberOfDueDate}} à partir du
                            {{repaymentSchedule.paymentStartDate }}
                        </span>
                    </ng-template>
                </a>
                <a *ngIf="!!repaymentSchedule" (click)="removeRepaymentSchedule()"
                   class="gup-C-moreInfos gup-O-link -secondary">
                    Supprimer
                </a>
            </div>
        </div>

        <!-- Spécifique chèque bancaire -->
        <ng-container *ngIf="hasSelectedCheque">

            <div class="gup-C-flexGroup -row -justifyBetween -alignStart">

                <!-- Numéro de chèque -->
                <div class="gup-C-flexGroup__item -demi">

                    <kal-form-field>

                        <kal-input formControlName="chequeNumber"
                                   id="activity_payment_methods_cheque_number"
                                   label="Numéro du chèque"
                                   [required]="isChequeNumberRequired && !repaymentSchedule">
                        </kal-input>

                    </kal-form-field>

                </div>

                <!-- Date de remise en banque -->
                <div class="gup-C-flexGroup__item -demi" *ngIf="isClientContext">
                    <kal-form-field>

                        <kal-datepicker formControlName="chequeDepositDate"
                                        id="activity_create_deposit_cheque_deposit_date"
                                        label="Date de remise en banque souhaitée">
                        </kal-datepicker>

                    </kal-form-field>
                </div>

            </div>

            <div class="gup-C-flexGroup -row -justifyBetween -alignStart" *ngIf="isClientContext">

                <!-- Banque -->
                <div class="gup-C-flexGroup__item -demi">

                    <kal-form-field>

                        <kal-input (kalAutocompleteSelected)="patchAutocompletedBank($event)"
                                   [kalAutocomplete]="autocompleteBankDataSource"
                                   formControlName="bankName"
                                   icon="keyboard_arrow_down"
                                   kalAutocompleteHeight="24vh"
                                   label="Banque"
                                   placeholder="Sélectionner une banque">
                        </kal-input>

                    </kal-form-field>

                </div>

                <!-- Nom tiré -->
                <div class="gup-C-flexGroup__item -demi">
                    <kal-form-field>

                        <kal-input formControlName="tiretName"
                                   id="activity_create_deposit_tire"
                                   label="Nom tiré">
                        </kal-input>

                    </kal-form-field>
                </div>

            </div>

        </ng-container>

        <!-- Spécifique prélèvement -->
        <ng-container *ngIf="hasSelectedBankTransfert">

            <!-- IBAN -->
            <div class="gup-C-flexGroup__item">

                <kal-form-field>

                    <kal-select formControlName="ibanId"
                                id="activity_payment_methods_iban"
                                label="IBAN">

                        <kal-option *ngFor="let iban of ibansList"
                                    [value]="iban.Id">
                            {{ (iban.CodePays + iban.CleIban + iban.Iban) | iban }}
                        </kal-option>

                    </kal-select>

                    <a *ngIf="canEditIban"
                       id="activity_payment_methods_add_iban"
                       class="gup-O-link -secondary small"
                       (click)="openEditIbanDialog({isCreation: true})">
                        <span>Ajouter un IBAN</span>
                    </a>

                </kal-form-field>

            </div>

            <!-- Mandat -->
            <div *ngIf="hasSelectedWithdrawal"
                 class="gup-C-flexGroup__item">

                <kal-form-field>

                    <kal-select formControlName="mandatId"
                                id="activity_payment_methods_mandat"
                                label="Mandat">

                        <kal-option *ngFor="let mandat of filteredMandatsList"
                                    [value]="mandat.Id">
                            {{ mandat.NumeroReference }}
                        </kal-option>

                    </kal-select>

                    <a id="activity_payment_methods_edit_mandat"
                       class="gup-O-link -secondary small"
                       (click)="openEditIbanDialog({isCreation: false})">
                        <span>Rattacher un mandat à un IBAN</span>
                    </a>

                </kal-form-field>

            </div>

        </ng-container>

        <!-- Compte collectif -->
        <div *ngIf="shouldDisplayCollectiveAccount"
             class="gup-C-flexGroup -row -justifyStart -alignCenter">

            <div class="gup-C-flexGroup__item -demi">

                <kal-form-field>

                    <kal-select formControlName="collectiveAccountId"
                                id="activity_payment_methods_collective_account"
                                label="Compte collectif">

                        <kal-option *ngFor="let collectiveAccount of collectiveAccountsList"
                                    [value]="collectiveAccount.Id">
                            {{ collectiveAccount.Numero }} - {{ collectiveAccount.Libelle }}
                        </kal-option>

                    </kal-select>

                </kal-form-field>

            </div>

        </div>

        <!-- Spécifique PMV / CCF -->
        <ng-container *ngIf="shouldDisplayPmvCcfAccount">

            <div class="gup-C-flexGroup -row -justifyBetween -alignStart">

                <!-- PMV / CCF -->
                <div class="gup-C-flexGroup__item -full">

                    <kal-form-field>

                        <kal-select formControlName="pmvCcfAccountId"
                                    id="activity_payment_methods_pmv_ccf_account"
                                    [label]="isClientContext ? 'Porte monnaie virtuel' : 'Compte courant fournisseur'">

                            <kal-option *ngFor="let account of pmvCcfAccountsList"
                                        [value]="account.IdCompte">
                                {{ account.NumeroCompte }} - {{ account.Libelle }}
                            </kal-option>

                        </kal-select>

                        <p class="small" [ngClass]="{'gup-O-status -is-refused': hasNotEnoughSoldeOnPmvCcf}">
                            Solde {{ hasNotEnoughSoldeOnPmvCcf ? 'insuffisant' : '' }}
                            : {{ selectPmvCcfAccount?.Solde | currency:'EUR' }}
                        </p>

                    </kal-form-field>

                </div>

            </div>

        </ng-container>

        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>

        <!-- Libellé -->
        <kal-form-field>
            <kal-input id="activity_payment_methods_label"
                       formControlName="label"
                       [label]="labelOfPaymentMethodLabel">
            </kal-input>
        </kal-form-field>

    </ng-container>

    <ng-template #defaultTemplate>

        <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

            <!-- Compte bancaire -->
            <div *ngIf="shouldDisplayBankAccount"
                 class="gup-C-flexGroup__item -demi">

                <kal-form-field>

                    <kal-select formControlName="bankAccountId"
                                id="activity_payment_methods_bank_account"
                                label="Compte bancaire">

                        <kal-option *ngFor="let bankAccount of bankAccountsList"
                                    [value]="bankAccount.Id">
                            {{ bankAccount.Libelle }}
                        </kal-option>

                    </kal-select>

                </kal-form-field>

            </div>

            <!-- Journal -->
            <div class="gup-C-flexGroup__item -full">

                <kal-form-field>

                    <kal-select formControlName="journalId"
                                id="activity_payment_methods_journal"
                                label="Journal">

                        <kal-option *ngFor="let journal of filtetedJournalsList"
                                    [value]="journal.Id">
                            {{ journal.Code }} - {{ journal.Libelle }}
                        </kal-option>

                    </kal-select>

                </kal-form-field>

            </div>

        </div>

        <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

            <!-- Collectif acompte -->
            <div class="gup-C-flexGroup__item -full" *ngIf="shouldDisplayCollectiveDepositAccount">

                <kal-form-field>

                    <app-shared-searchbar-list formControlName="depositAccountId"
                                               id="activity_payment_methods_deposit_account"
                                               label="Collectif acompte">

                        <kal-option *ngFor="let depositAccount of depositCollectiveAccountsList"
                                    [value]="depositAccount.Id">
                            {{ depositAccount.Numero }} - {{ depositAccount.Libelle }}
                        </kal-option>

                    </app-shared-searchbar-list>

                </kal-form-field>

            </div>

            <div *ngIf="shouldDisplayPartNumber"
                 class="gup-C-flexGroup__item -demi">
                <!-- Numéro de pièce -->
                <app-part-number formControlName="partNumber"
                                 [criteria]="partNumberCriterias">
                </app-part-number>
            </div>

        </div>
    </ng-template>

</div>
